import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import { Marker, TileLayer } from "react-leaflet";
import { useMapEvents } from "react-leaflet/hooks";
import "leaflet/dist/leaflet.css";
import { MapContainer } from "react-leaflet";
import { Box, Button, Dialog, DialogTitle, Typography } from "@mui/material";
import MapOrder from "../addOrder/MapOrder";

export default function ChangeLocation(props) {
  const [markerLatLng, setMarkerLatLng] = useState([
    props.myLocations.latitude ? props.myLocations.latitude : 35.7009,
    props.myLocations.longitude ? props.myLocations.longitude : 51.391241,
  ]);

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={() => {
        props.setShowChangelocState(false);
      }}
      open={props.showchangelocState}
    >
      <DialogTitle>
        <Typography variant="subtitle1">ویرایش آدرس</Typography>
      </DialogTitle>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <MapContainer
          center={[
            props.myLocations.latitude ? props.myLocations.latitude : 35.7009,
            props.myLocations.longitude
              ? props.myLocations.longitude
              : 51.391241,
          ]}
          // center={center}
          zoom={15}
          style={{
            height: "350px",
            width: "800px",
          }}
        >
          <MapOrder
            myLocations={props.myLocations}
            setMyLocations={props.setMyLocations}
          />
        </MapContainer>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            sx={{ my: 3 }}
            variant="contained"
            color="secondary"
            onClick={() => props.callback()}
          >
            ثبت
          </Button>
          <Button
            sx={{ my: 3 }}
            variant="outlined"
            onClick={() => props.setShowChangelocState(false)}
          >
            انصراف
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
